class RecentlyViewed extends HTMLElement {
 constructor() {
  super();

  if (typeof Storage === 'undefined') {
    this.hidden = true;
    return;
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) {
        this.init();
        obs.disconnect();
      }
    }, {
      rootMargin: '600px 0px 600px 0px'
    });

    observer.observe(this);
  } else {
    this.init();
  }
}

  init() {
    fetch(this.getAttribute('data-url') + this.getQueryString())
      .then(response => response.text())
      .then(responseText => {
        console.log(responseText,"repsonsetext")
        const sectionInnerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.shopify-section');

        const recommendations = sectionInnerHTML.querySelector('recently-viewed');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.dispatchEvent(new CustomEvent('recentlyViewed:loaded'));
        }
        else {
          this.closest('.recently-section')?.remove();
          this.dispatchEvent(new CustomEvent('is-empty'));
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

getQueryString() {
  let recentlyViewed = '[]';

  if (typeof Storage !== 'undefined') {
    recentlyViewed = window.localStorage.getItem('recently-viewed') || '[]';
  }

  const items = new Set(JSON.parse(recentlyViewed));

  if (this.hasAttribute('data-product-id')) {
    items.delete(parseInt(this.getAttribute('data-product-id')));
  }

  return Array.from(items.values(), (item) => `id:${item}`)
    .slice(0, this.hasAttribute('data-limit') ? parseInt(this.getAttribute('data-limit')) : 4)
    .join(' OR ');
}
}
customElements.define('recently-viewed', RecentlyViewed);
